import { Merchant } from './../../Merchant';
import { Component, OnInit, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { MerchantsComponent } from '../merchants/merchants.component';

@Component({
  selector: 'app-merchant-profiles',
  templateUrl: './merchant-profiles.component.html',
  styleUrls: ['./merchant-profiles.component.css']
})
export class MerchantProfilesComponent extends MerchantsComponent
  implements OnInit {
  submitted = false;
  firstParameter = '';
  whichView = 'none';
  processing = false;
  selectedMerchant: string;
  results: Merchant[];

  constructor(injector: Injector, private router: Router) {
    super(injector);
  }

  ngOnInit() {
    this.merchantService.merchantSelected.subscribe((merchant: Merchant) => {
      this.router.navigate(['/merchantProfiles/accounts']);
    });
  }

  hasEntitlement(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  submit() {}
}
